import { Funnel } from '../types/funnel.types';

/**
 * Import funnel from JSON file
 */
export const importFromJSON = (file: File): Promise<Funnel> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const json = event.target?.result as string;
        const funnel: Funnel = JSON.parse(json);
        
        // Validate the funnel structure
        if (!funnel.id || !funnel.name || !Array.isArray(funnel.sections)) {
          throw new Error('Invalid funnel structure');
        }

        resolve(funnel);
      } catch (error) {
        reject(new Error('Failed to parse JSON file'));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};

/**
 * Validate funnel data structure
 */
export const validateFunnel = (data: any): data is Funnel => {
  return (
    typeof data === 'object' &&
    data !== null &&
    typeof data.id === 'string' &&
    typeof data.name === 'string' &&
    Array.isArray(data.sections) &&
    typeof data.metadata === 'object'
  );
};

